<template>
    <div class="column">
        <table class="table is-fullwidth is-bordered">
            <thead>
            <tr>
                <th class="narrow"></th>
                <th>Sale Item</th>
                <th>Inland</th>
                <th>Total</th>
                <th class="narrow"></th>
            </tr>
            </thead>
            <tbody>
            <custom-invoice-sales-table-row v-for="(item, index) in items" :item="item" :index="index"></custom-invoice-sales-table-row>
            <custom-invoice-sales-table-create-row></custom-invoice-sales-table-create-row>
            </tbody>
        </table>
    </div>
</template>

<script>
    import CustomInvoiceSalesTableRow from './CustomInvoiceSalesTableRow'
    import CustomInvoiceSalesTableCreateRow from './CustomInvoiceSalesTableCreateRow'
    export default {
        components: {
            CustomInvoiceSalesTableRow,
            CustomInvoiceSalesTableCreateRow
        },
        computed: {
            items() {
                return this.$store.getters.getCustomInvoiceSaleItems
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
    .narrow {
        width: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceSalesTable.vue